import React, { Component } from 'react';
import Login from './login';
import userId from '../functions/userid';
import Drawer from './drawer';

class Admin extends Component {

  getUserId() {
    let user;
    try {
      user = userId();
    } catch (e) {
      user = '';
    }
    return user;
  }


  render() {
    let user = this.getUserId();
    return (
      <div>
        {
          user ? (<div><Drawer /></div>) : (<div><Login /></div>)
        }
      </div>
    );
  }
}

export default Admin;
